/* @flow */

import React from "react";
import { Helmet } from "react-helmet-async";
import { Wrapper } from "@crossroads/ui-components";
import { useTranslate } from "@awardit/react-use-translate";
import { HttpNotFound } from "@crossroads/express-utils";
import styles from "./styles.scss";

const NotFound = (): React$Node => {
  const t = useTranslate();

  return (
    <Wrapper className={styles.topMargin}>
      <Helmet
        title={t("404.TITLE")}
      />

      <h1>{t("404.HEADING")}</h1>
      <h2>{t("404.SUBHEADING")}</h2>
      <HttpNotFound />
    </Wrapper>
  );
};

export default NotFound;
